var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIdinline = function SvgIdinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.571 3A2.585 2.585 0 0 0 0 5.571v12a2.585 2.585 0 0 0 2.571 2.572H21.43A2.585 2.585 0 0 0 24 17.57v-12A2.585 2.585 0 0 0 21.429 3H2.57Zm0 1.714H21.43c.485 0 .857.372.857.857v12a.842.842 0 0 1-.857.858H2.57a.842.842 0 0 1-.857-.858v-12c0-.485.372-.857.857-.857ZM7.714 6.43a3.44 3.44 0 0 0-3.428 3.428 3.41 3.41 0 0 0 1.044 2.438 4.317 4.317 0 0 0-1.901 3.562h1.714a2.56 2.56 0 0 1 2.571-2.571 2.56 2.56 0 0 1 2.572 2.571H12c0-1.473-.76-2.789-1.902-3.562a3.41 3.41 0 0 0 1.045-2.438A3.44 3.44 0 0 0 7.714 6.43Zm6 .857V9h6.857V7.286h-6.857Zm-6 .857A1.7 1.7 0 0 1 9.43 9.857a1.7 1.7 0 0 1-1.715 1.714A1.7 1.7 0 0 1 6 9.857a1.7 1.7 0 0 1 1.714-1.714Zm6 2.571v1.715h6.857v-1.715h-6.857Zm0 3.429v1.714H18v-1.714h-4.286Z"
  })));
};

export default SvgIdinline;